var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6736 5.29932H3.80299C2.23989 5.29932 0.977051 6.60648 0.977051 8.22444C0.977051 9.8424 2.23989 11.1496 3.80299 11.1496H14.1972C15.7603 11.1496 17.0231 12.4567 17.0231 14.0747C17.0231 15.6926 15.7603 16.9998 14.1972 16.9998H1.40977",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6787 3.40698H11.0622C10.872 3.40698 10.7178 3.56659 10.7178 3.76348V6.81658C10.7178 7.01347 10.872 7.17308 11.0622 7.17308H16.6787C16.869 7.17308 17.0232 7.01347 17.0232 6.81658V3.76348C17.0232 3.56659 16.869 3.40698 16.6787 3.40698Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7686 0.975586L15.9986 3.40709",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.000f9823c4d8119822115b85ef1ebbf1.svg";
export { ForwardRef as ReactComponent };